import { Badge } from "@/components/ui/badge.tsx";
import type { ArtifactComponent } from "@/types/artifacts-view.ts";

type BadgeComponentData = Extract<ArtifactComponent, { type: "badge" }>;

export const BadgeBlock = ({ component }: { component: BadgeComponentData }) => {
  return (
    <Badge variant={component.variant} className="text-xs">
      {component.label}
    </Badge>
  );
};
